import React, { useState, useEffect } from 'react';
import SimpleBar from 'simplebar-react';
import Tooltip from '../Tooltip';

function FilterContainer(props) {
  const {
    className,
    label,
    selected,
    taxSlug,
    scrollable,
    collapsible,
    filterId,
    tooltip,
    tooltipLeftContent,
    tooltipRightContent,
    labelTitle,
  } = props;

  const collapseClass = collapsible ? 'collapsible' : '';
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  let content;
  let labelcontent;
  let tooltipElement;
  let decoratorClass = '';
  const activeLabel = labelTitle ? labelTitle : label;

  function countClass() {
    let classString = '';

    if (count > 0) {
      classString = 'count-visible';
    }

    if (tooltip) {
      classString += ' has-tooltip';
    }

    return classString;
  }

  function updateCount() {
    if (selected && taxSlug && selected.hasOwnProperty(taxSlug)) {
      setCount(selected[taxSlug].length);
    }
  }

  function toggleOpen() {
    if (collapsible) {
      setOpen(!open);
    }
  }

  function toggleClass() {
    let classString = '';

    if (open) {
      classString = 'open';
    }

    return classString;
  }

  if (scrollable) {
    content = <SimpleBar>{props.children}</SimpleBar>
  }
  else {
    content = props.children;
  }

  if (activeLabel) {
    labelcontent = <h6 onClick={() => toggleOpen()} className={countClass()} data-count={count}>
      <span>{activeLabel}</span>
    </h6>
  }

  if (tooltip && tooltipLeftContent || tooltipRightContent) {

    tooltipElement = <Tooltip
      leftContent={tooltipLeftContent}
      rightContent={tooltipRightContent}
    ></Tooltip>
  }

  useEffect(() => {
    updateCount();
  }, [selected]);

  return (
    <div id={filterId} className={`eight29-filter ${className} ${decoratorClass}`}>
      <div className={`accordion-select ${toggleClass()} ${collapseClass}`}>
        <div className="eight29-filter-header">
          {labelcontent}
          {tooltipElement}
        </div>
        <div>
          {content}
          {tooltipElement}
        </div>
      </div>
    </div>
  )
}

export default FilterContainer;